/**
 * SbcLogo — classic Coca-Cola-style red "SBC / LTD" wordmark.
 * Uses inline SVG so it scales sharply on any screen (retina, PWA icon, print).
 */
export default function SbcLogo({ className = "h-12 w-auto" }) {
  return (
    <svg
      viewBox="0 0 120 74"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="SBC Ltd"
      data-testid="sbc-logo"
    >
      {/* SBC big letters */}
      <text
        x="60"
        y="42"
        textAnchor="middle"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontWeight="900"
        fontStyle="italic"
        fontSize="46"
        fill="#C81E1E"
        letterSpacing="-1"
      >SBC</text>
      {/* underline flourishes */}
      <line x1="15" y1="52" x2="45" y2="52" stroke="#C81E1E" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="75" y1="52" x2="105" y2="52" stroke="#C81E1E" strokeWidth="2.4" strokeLinecap="round" />
      {/* LTD sub-line */}
      <text
        x="60"
        y="68"
        textAnchor="middle"
        fontFamily="Helvetica, Arial, sans-serif"
        fontWeight="700"
        fontSize="14"
        fill="#C81E1E"
        letterSpacing="4"
      >LTD</text>
    </svg>
  );
}
